/**
 * asForm Higher Order Component
 */
import React from 'react';
import { action } from 'mobx';

const asForm = (MyComponent, formDataProp) => (props) => {
  const updateProperty = action((key, value) => {
    props[formDataProp][key] = value;
    // creates BillingName from FullName for indiviuals
    if (key == 'FullName' && props[formDataProp]['Custom1'] == 'Individual') {
      props[formDataProp]['BillingName'] = value;
    }
    // links CompanyName with BillingName
    if (key == 'CompanyName') {
      props[formDataProp]['BillingName'] = value;
    }
    // Saves Address to Billing Address when Billing Address is Empty
    if (isNewSignup(props[formDataProp]) && isPersonalAddressKey(key)) {
      const billingKey = getBillingKeyFromPersonalAddressKey[key];
      props[formDataProp][billingKey] = value;
    }
  });

  return <MyComponent {...props} updateProperty={updateProperty} />;
};

// helper functions

const isNewSignup = (customer) => {
  return !customer.Id;
};

const isPersonalAddressKey = (key) => {
  return ['Address', 'CityName', 'PostCode'].includes(key);
};

const getBillingKeyFromPersonalAddressKey = {
  Address: 'BillingAddress',
  CityName: 'BillingCityName',
  PostCode: 'BillingPostCode',
};

export default asForm;
